skrilla.directive('userSportsExclusionsRegister', function () {
    return {
        templateUrl: 'directives/userSportsExclusionsRegister/userSportsExclusionsRegister.html',
        scope: {
            user: "="
        },

        controller: async function ($scope, searchService, paginationService, queryService, srefService, cacheService,
                                    modalService, sportService, userExclusionsService) {
            $scope.sports = await sportService.getSports()
            $scope.pageKey = "userSportsExclusionsRegister";
            userExclusionsService.getRequesterTypes('sports').then(function(requesters) {
                $scope.requesters = requesters
            });
            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
            }};
            $scope.reset()
            $scope.resetSearchParam = function(searchParam) {
                $scope.query[searchParam] = null
            }
            $scope.search = function(){
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getUserSportsExclusions, $scope.pageKey);
            }

            function getUserSportsExclusions() {
                return searchService.get("sportsExclusions/users" + queryService.getQueryString($scope.query, $scope.pageKey))
                    .then(function(response) {
                        $scope.userExclusions = response.data.result;
                        paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                    });
            }

            $scope.effectiveUntilColour = function (date) {
                return userExclusionsService.getEffectiveUntilColour(date)
            }

            $scope.search()
        }
    };
});